import { IRequest } from "../interfaces/authentication.interface";
import { IVimeo } from "../interfaces/vimeo.interface";
import { vimeoRequest } from "./requests.service";

export const getVideo = async (videoId?: string): Promise<IRequest<IVimeo | null>> => {
    try {
        if (!videoId) throw Error();

        const response = await vimeoRequest.get<{ files: IVimeo[] }>(
            `/videos/${videoId}?fields=files`
        );
        const video = response.data.files.find((vid) => vid.rendition === "720p");

        if (!video) throw Error();

        return { success: true, data: video };
    } catch (error: any) {
        return { success: false, data: null };
    }
};
